import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: '#7833FF',
  },
  secondaryColor: {
    color: '#D6246E',
  },
  whiteColor: {
    color: theme.palette.common.white,
  },
  orangeBg: {
    backgroundColor: '#F97E30',
  },
  negativeContainer: {
    position: 'relative',
    top: -275,
  },
  greySection: {
    padding: theme.spacing(6, 4),
    textAlign: 'center',
    backgroundColor: '#DEDDDF',
    borderTopLeftRadius: theme.spacing(1),
    borderTopRightRadius: theme.spacing(1),
  },
  primarySection: {
    padding: theme.spacing(6, 4),
    textAlign: 'center',
    color: theme.palette.common.white,
    backgroundColor: '#371777',
    borderBottomLeftRadius: theme.spacing(1),
    borderBottomRightRadius: theme.spacing(1),
  },
  button: {
    padding: theme.spacing(1.5, 3),
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightBold,
    borderRadius: 40,
  },
  secondaryButton: {
    backgroundColor: '#D6246E',
  },
  whiteButton: {
    color: theme.palette.common.white,
    background: 'none',
    border: `1px solid ${theme.palette.common.white}`,
    boxShadow: 'none',

    '&:hover': {
      backgroundColor: theme.palette.common.white,
      color: '#7833FF',
    },
  },
  sectionTitle: {
    color: '#7833FF',

    '& svg': {
      marginRight: theme.spacing(1),
      verticalAlign: 'text-top',
    },
  },
  sectionImage: {
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
    margin: '0 auto',
  },
  icon: {
    height: 90,
  },
  primaryTitle: {
    position: 'relative',
    marginBottom: theme.spacing(10),
    color: '#371777',
    textAlign: 'center',

    '&::before': {
      content: '""',
      display: 'block',
      width: 250,
      height: 7,
      position: 'absolute',
      left: '50%',
      bottom: -15,
      marginLeft: -125,
      backgroundColor: '#371777',
      borderRadius: 5,
    },
  },
  list: {
    margin: 0,
    padding: theme.spacing(0, 2),

    '& li': {
      marginBottom: theme.spacing(1),
      color: '#7833FF',
    },

    '& span': {
      color: theme.palette.text.primary,
    },
  },
}));
